<h2 class="title dashboard-subheading">{{ 'campaigns.zones.TITLE' | translate }}</h2>
<h3 class="site">{{ site.siteName }}</h3>
<app-campaigns-planner-zones-table></app-campaigns-planner-zones-table>
<app-campaigns-planner-zones-form [site]="site"></app-campaigns-planner-zones-form>
<div class="section-buttons">
    <button mat-flat-button color="primary" class="btn" type="button" (click)="changeSection.emit('summary')">
        {{ 'general.actions.BACK' | translate }}
    </button>
</div>